export class BienSolicitudEntity{
    constructor(
        public CodigoUsuario?:number,
        public CodigoCiudadTecni?:number,
        public CodigoCliente?:number,
        public CodigoProducto?:number,
        public CodigoBienAsegurado?:number,
        public TipoSolicitud?:number,
        public CodigoMotivoCancelacion?:number,
        public TipoCobertura?:number,
        public NombreProducto?:string,
        public Observaciones?:string
        ){}
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/bien_asegurado_entity.ts